// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   RiFileTextLine,
//   RiCheckLine,
//   RiErrorWarningLine,
//   RiCloseLine,
//   RiCalendarLine,
//   RiArrowLeftLine,
//   RiInformationLine,
//   RiPrinterLine,
//   RiBuildingLine,
//   RiUserLine,
//   RiShieldLine,
//   RiDownload2Line,
//   RiBankLine,
//   RiPhoneLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { generateInvoicePDF } from "../Util/GenerateInvoicePDF";

// const BASE_URL = process.env.REACT_APP_API_URL;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, []);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const fmtNum = (n) =>
//   Number(n || 0).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// const Label = ({ children }) => (
//   <label className="text-[10px] font-semibold text-blue-600 uppercase tracking-widest mb-1 block">
//     {children}
//   </label>
// );

// const inputCls =
//   "w-full bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition";

// const defaultForm = {
//   invoiceNumber: "",
//   date: "",
//   pan: "",
//   gstNumber: "",
//   customerId: "",
//   hsnCode: "998363",
//   cgstRate: 2.5,
//   sgstRate: 2.5,
//   notes: "",
//   selectedBank: null,
//   selectedQuery: null,
//   billTo: {
//     name: "",
//     company: "",
//     address: "",
//     phone: "",
//     gstNumber: "",
//   },
// };

// const ROInfoBadge = ({ label, value, icon: Icon }) => (
//   <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2">
//     {Icon && <Icon className="w-3.5 h-3.5 text-blue-400 flex-shrink-0" />}
//     <div className="min-w-0">
//       <div className="text-[9px] font-bold text-blue-400 uppercase tracking-widest">
//         {label}
//       </div>
//       <div className="text-xs font-semibold text-slate-700 truncate">
//         {value || "—"}
//       </div>
//     </div>
//   </div>
// );

// // ── amount-in-words ────────────────────────────────────────────────────────
// const ones = [
//   "",
//   "One",
//   "Two",
//   "Three",
//   "Four",
//   "Five",
//   "Six",
//   "Seven",
//   "Eight",
//   "Nine",
//   "Ten",
//   "Eleven",
//   "Twelve",
//   "Thirteen",
//   "Fourteen",
//   "Fifteen",
//   "Sixteen",
//   "Seventeen",
//   "Eighteen",
//   "Nineteen",
// ];
// const tens = [
//   "",
//   "",
//   "Twenty",
//   "Thirty",
//   "Forty",
//   "Fifty",
//   "Sixty",
//   "Seventy",
//   "Eighty",
//   "Ninety",
// ];
// function numToWords(n) {
//   n = Math.round(n);
//   if (n === 0) return "Zero";
//   if (n < 0) return "Minus " + numToWords(-n);
//   if (n < 20) return ones[n];
//   if (n < 100)
//     return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
//   if (n < 1000)
//     return (
//       ones[Math.floor(n / 100)] +
//       " Hundred" +
//       (n % 100 ? " " + numToWords(n % 100) : "")
//     );
//   if (n < 100000)
//     return (
//       numToWords(Math.floor(n / 1000)) +
//       " Thousand" +
//       (n % 1000 ? " " + numToWords(n % 1000) : "")
//     );
//   if (n < 10000000)
//     return (
//       numToWords(Math.floor(n / 100000)) +
//       " Lakh" +
//       (n % 100000 ? " " + numToWords(n % 100000) : "")
//     );
//   return (
//     numToWords(Math.floor(n / 10000000)) +
//     " Crore" +
//     (n % 10000000 ? " " + numToWords(n % 10000000) : "")
//   );
// }

// export default function CreateInvoiceByReleaseOrder() {
//   const { part1, part2, part3 } = useParams();
//   const baseRONumber = `${part1}/${part2}/${part3}`;
//   const navigate = useNavigate();

//   const [roGroup, setRoGroup] = useState(null);
//   const [form, setForm] = useState(defaultForm);
//   const [itemEdits, setItemEdits] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false);
//   const [toast, setToast] = useState(null);
//   const [saved, setSaved] = useState(null);
//   const [company, setCompany] = useState({});
//   const [bankList, setBankList] = useState([]);
//   const [queryList, setQueryList] = useState([]);

//   const notify = (message, type = "success") => setToast({ message, type });

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const [roRes, companyRes] = await Promise.allSettled([
//           axios.get(
//             `${BASE_URL}/releaseOrder/release-orders/base/${baseRONumber}`,
//           ),
//           axios.get(`${BASE_URL}/company/get`),
//         ]);

//         if (roRes.status === "fulfilled") {
//           const roData = roRes.value?.data?.data || roRes.value?.data;
//           setRoGroup(roData);

//           const allItems =
//             roData.variants?.flatMap((v) => v.items || []) ||
//             roData.items ||
//             [];

//           const edits = allItems.map((item) => ({
//             width: item.width ?? "",
//             height: item.height ?? "",
//             rate: item.ratePerSqCm || item.rate || "",
//             page: String(item.pagePosition || ""),
//           }));
//           setItemEdits(edits);

//           setForm((f) => ({
//             ...f,
//             baseRONumber: baseRONumber,
//             billTo: {
//               name: roData.client?.contactPerson || roData.client?.name || "",
//               company: roData.client?.bankName || "",
//               address: roData.client?.address || "",
//               phone: roData.client?.phone || "",
//               gstNumber: roData.client?.gstno || roData.client?.gstNumber || "",
//             },
//             customerId: roData.client?.customer_id || "",
//           }));

//           try {
//             const invRes = await axios.get(
//               `${BASE_URL}/invoice/getInvoiceNumber/${baseRONumber}`,
//             );
//             const d = invRes.data?.data;
//             if (d?.invoiceNumber) {
//               setForm((f) => ({
//                 ...f,
//                 invoiceNumber: d.invoiceNumber,
//                 date: d.invoiceDate || f.date,
//               }));
//             }
//           } catch (invError) {
//             console.log("Could not fetch invoice number:", invError);
//           }
//         } else {
//           notify("Failed to load release order", "error");
//         }

//         if (companyRes.status === "fulfilled") {
//           const companyData =
//             companyRes.value?.data?.data || companyRes.value?.data;
//           setCompany(companyData);

//           const banks = companyData?.bankDetails || [];
//           const queries = companyData?.queryDetails || [];
//           setBankList(banks);
//           setQueryList(queries);

//           setForm((f) => ({
//             ...f,
//             pan: f.pan || companyData?.pan || "",
//             gstNumber: f.gstNumber || companyData?.gst || "",
//             // Auto-select first bank and query if available
//             selectedBank: banks.length > 0 ? banks[0] : null,
//             selectedQuery: queries.length > 0 ? queries[0] : null,
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         notify("Failed to load data", "error");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (baseRONumber) {
//       fetchData();
//     }
//   }, [baseRONumber]);

//   const set = (key, val) => setForm((f) => ({ ...f, [key]: val }));
//   const setBillTo = (key, val) =>
//     setForm((f) => ({ ...f, billTo: { ...f.billTo, [key]: val } }));

//   const updateItemEdit = (idx, field, val) =>
//     setItemEdits((prev) =>
//       prev.map((e, i) => (i === idx ? { ...e, [field]: val } : e)),
//     );

//   const previewItems = roGroup
//     ? (roGroup.variants?.flatMap((v) => v.items) || roGroup.items || []).map(
//         (item, idx) => {
//           const edit = itemEdits[idx] || {};
//           const width =
//             edit.width !== "" ? Number(edit.width) : item.width || 0;
//           const height =
//             edit.height !== "" ? Number(edit.height) : item.height || 0;
//           const rate =
//             edit.rate !== ""
//               ? Number(edit.rate)
//               : item.ratePerSqCm || item.rate || 0;
//           const volume = width * height;
//           const amount = volume * rate;
//           return {
//             roNumber: item.roNumber || "—",
//             publication: item.publication || "",
//             edition: item.edition || "",
//             hue: item.hue || "B/W",
//             dop: item.dop ? new Date(item.dop).toLocaleDateString("en-IN") : "",
//             pagePosition: item.pagePosition || "",
//             page:
//               itemEdits[idx]?.page !== undefined && itemEdits[idx]?.page !== ""
//                 ? itemEdits[idx].page
//                 : item.pagePosition || "",
//             width,
//             height,
//             volume,
//             rate,
//             amount,
//           };
//         },
//       )
//     : [];

//   const subTotal = previewItems.reduce((s, i) => s + i.amount, 0);
//   const cgstAmt = (subTotal * Number(form.cgstRate || 0)) / 100;
//   const sgstAmt = (subTotal * Number(form.sgstRate || 0)) / 100;
//   const total = subTotal + cgstAmt + sgstAmt;
//   const amtWords = numToWords(Math.round(total)) + " Only";

//   const handleSubmit = async () => {
//     if (!form.invoiceNumber)
//       return notify("Invoice number is required", "error");

//     setSubmitting(true);
//     try {
//       const itemOverridesWithPage = itemEdits.map((edit) => ({
//         ...edit,
//         page: edit.page || "",
//       }));

//       const payload = {
//         ...form,
//         baseRONumber: baseRONumber,
//         itemOverrides: itemOverridesWithPage,
//       };

//       const res = await axios.post(`${BASE_URL}/invoice/create`, payload);
//       const createdInvoice = res.data?.data || res.data;

//       setSaved(createdInvoice);
//       notify("Invoice created successfully for all variants!");
//       setTimeout(() => {
//         navigate(`/admin/all-invoice`);
//       }, 2000);
//     } catch (err) {
//       console.error("Invoice creation error:", err);
//       notify(
//         err?.response?.data?.message || "Failed to create invoice",
//         "error",
//       );
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleDownloadPDF = () => {
//     const invoiceData = {
//       invoiceNumber: form.invoiceNumber,
//       date: form.date,
//       pan: form.pan,
//       gstNumber: form.gstNumber,
//       customerId: form.customerId,
//       hsnCode: form.hsnCode,
//       cgstRate: Number(form.cgstRate),
//       sgstRate: Number(form.sgstRate),
//       cgstAmount: cgstAmt,
//       sgstAmount: sgstAmt,
//       subTotal,
//       totalAmount: total,
//       amountInWords: amtWords,
//       billTo: form.billTo,
//       items: previewItems,
//       company,
//       selectedBank: form.selectedBank,
//       selectedQuery: form.selectedQuery,
//     };
//     generateInvoicePDF(invoiceData);
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-slate-50 flex items-center justify-center">
//         <div className="flex flex-col items-center gap-4 text-blue-400">
//           <Spinner className="w-10 h-10" />
//           <span className="text-sm font-medium">Loading release order…</span>
//         </div>
//       </div>
//     );
//   }

//   if (!roGroup) {
//     return (
//       <div className="min-h-screen bg-slate-50 flex items-center justify-center">
//         <div className="text-center">
//           <RiErrorWarningLine className="w-12 h-12 text-red-400 mx-auto mb-3" />
//           <p className="text-slate-600 font-semibold mb-4">
//             Release order not found.
//           </p>
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center gap-2 px-5 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold mx-auto"
//           >
//             <RiArrowLeftLine className="w-4 h-4" /> Go Back
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const totalVariants = roGroup.variants?.length || 1;
//   const totalItems =
//     roGroup.variants?.reduce((sum, v) => sum + (v.items?.length || 0), 0) || 0;

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-800">
//       {/* ── Header ── */}
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4">
//           <div className="flex items-center gap-3">
//             <button
//               onClick={() => navigate(-1)}
//               className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-700 hover:bg-blue-50 transition"
//             >
//               <RiArrowLeftLine className="w-4 h-4" />
//             </button>
//             <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-md shadow-indigo-200">
//               <RiPrinterLine className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-indigo-800 tracking-tight">
//                 Create Invoice
//               </h1>
//               <p className="text-[11px] text-indigo-400 tracking-widest uppercase">
//                 {totalVariants} variant{totalVariants !== 1 ? "s" : ""} •{" "}
//                 {totalItems} items
//               </p>
//             </div>
//           </div>

//           <div className="hidden md:flex items-center gap-2">
//             <ROInfoBadge
//               label="Base RO"
//               value={baseRONumber}
//               icon={RiFileTextLine}
//             />
//             <ROInfoBadge
//               label="Client"
//               value={roGroup?.client?.bankName}
//               icon={RiBuildingLine}
//             />
//             <ROInfoBadge
//               label="Variants"
//               value={`${totalVariants}`}
//               icon={RiUserLine}
//             />
//           </div>
//         </div>
//       </header>

//       <div className="px-6 py-6 pb-24 mx-auto space-y-5 w-full">
//         {/* ── RO Summary Banner ── */}
//         <div className="bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl p-5 text-white shadow-lg shadow-indigo-200/50">
//           <div className="flex items-start justify-between gap-4 flex-wrap">
//             <div>
//               <div className="text-indigo-200 text-[10px] font-bold uppercase tracking-widest mb-1">
//                 Base Release Order
//               </div>
//               <div className="text-xl font-extrabold tracking-tight mb-1">
//                 {baseRONumber}
//               </div>
//               <div className="text-indigo-200 text-sm">
//                 {totalVariants} variant{totalVariants !== 1 ? "s" : ""} combined
//               </div>
//             </div>
//             <div className="flex flex-col items-end gap-1">
//               <div className="text-indigo-200 text-[10px] font-bold uppercase tracking-widest">
//                 Total Items
//               </div>
//               <div className="text-3xl font-extrabold">{totalItems}</div>
//             </div>
//           </div>
//           <div className="flex items-center gap-3 mt-4 pt-4 border-t border-indigo-500/40 md:hidden flex-wrap">
//             <span className="text-xs text-indigo-200">
//               <span className="font-semibold text-white">Client: </span>
//               {roGroup.client?.bankName}
//             </span>
//             <span className="text-xs text-indigo-200">
//               <span className="font-semibold text-white">Variants: </span>
//               {totalVariants}
//             </span>
//           </div>
//         </div>

//         {/* ── Step 1: Invoice Details ── */}
//         <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//           <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center gap-2">
//             <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
//               1
//             </span>
//             <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//               Invoice Details
//             </span>
//           </div>

//           <div className="p-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
//             <div>
//               <Label>Invoice Number</Label>
//               <input
//                 value={form.invoiceNumber}
//                 onChange={(e) => set("invoiceNumber", e.target.value)}
//                 className={inputCls}
//                 placeholder="e.g. NG/1137/25-26"
//               />
//             </div>
//             <div>
//               <Label>Date</Label>
//               <div className="relative">
//                 <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//                 <input
//                   type="date"
//                   value={form.date}
//                   onChange={(e) => set("date", e.target.value)}
//                   className={`${inputCls} pl-9`}
//                 />
//               </div>
//             </div>
//             <div>
//               <Label>PAN</Label>
//               <input
//                 value={form.pan}
//                 onChange={(e) => set("pan", e.target.value)}
//                 className={inputCls}
//                 placeholder="ALBPD0451G"
//               />
//             </div>
//             <div>
//               <Label>Our GST No.</Label>
//               <input
//                 value={form.gstNumber}
//                 onChange={(e) => set("gstNumber", e.target.value)}
//                 className={inputCls}
//                 placeholder="21ALBPD0451G2Z0"
//               />
//             </div>
//             <div>
//               <Label>Customer ID</Label>
//               <input
//                 value={form.customerId}
//                 onChange={(e) => set("customerId", e.target.value)}
//                 className={inputCls}
//                 placeholder="UBI/BALASORE"
//               />
//             </div>
//             <div>
//               <Label>HSN Code</Label>
//               <input
//                 value={form.hsnCode}
//                 onChange={(e) => set("hsnCode", e.target.value)}
//                 className={inputCls}
//                 placeholder="998363"
//               />
//             </div>
//           </div>
//         </div>

//         {/* ── Step 2: Bill To ── */}
//         <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//           <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
//                 2
//               </span>
//               <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Bill To
//               </span>
//             </div>
//             <span className="text-[10px] text-indigo-400 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-full font-semibold">
//               Pre-filled from RO client
//             </span>
//           </div>
//           <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
//             <div>
//               <Label>Name / Designation</Label>
//               <input
//                 value={form.billTo.name}
//                 onChange={(e) => setBillTo("name", e.target.value)}
//                 className={inputCls}
//                 placeholder="The Regional Manager"
//               />
//             </div>
//             <div>
//               <Label>Company / Bank</Label>
//               <input
//                 value={form.billTo.company}
//                 onChange={(e) => setBillTo("company", e.target.value)}
//                 className={inputCls}
//                 placeholder="Union Bank of India"
//               />
//             </div>
//             <div className="col-span-full">
//               <Label>Address</Label>
//               <input
//                 value={form.billTo.address}
//                 onChange={(e) => setBillTo("address", e.target.value)}
//                 className={inputCls}
//                 placeholder="Manikhambu, OT Road, Police Line…"
//               />
//             </div>
//             <div>
//               <Label>Phone No.</Label>
//               <input
//                 value={form.billTo.phone}
//                 onChange={(e) => setBillTo("phone", e.target.value)}
//                 className={inputCls}
//                 placeholder="Phone"
//               />
//             </div>
//             <div>
//               <Label>GST No. (Client)</Label>
//               <div className="relative">
//                 <RiShieldLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//                 <input
//                   value={form.billTo.gstNumber}
//                   onChange={(e) => setBillTo("gstNumber", e.target.value)}
//                   className={`${inputCls} pl-9`}
//                   placeholder="21AAACUØ564G2ZS"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ── Step 3: Bank Account & Query Contact ── */}
//         <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//           <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
//                 3
//               </span>
//               <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Payment & Contact Details
//               </span>
//             </div>
//             <span className="text-[10px] text-indigo-400 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-full font-semibold">
//               Shown on invoice
//             </span>
//           </div>

//           <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
//             {/* ── Bank Account ── */}
//             <div>
//               <Label>Bank Account</Label>
//               {bankList.length === 0 ? (
//                 <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
//                   <RiInformationLine className="w-4 h-4 flex-shrink-0" />
//                   No bank accounts found. Add one in Company Settings.
//                 </div>
//               ) : (
//                 <select
//                   value={
//                     form.selectedBank
//                       ? JSON.stringify({
//                           accountNumber: form.selectedBank.accountNumber,
//                           ifscCode: form.selectedBank.ifscCode,
//                           branchName: form.selectedBank.branchName,
//                           branchAddress: form.selectedBank.branchAddress,
//                         })
//                       : ""
//                   }
//                   onChange={(e) => {
//                     if (!e.target.value) {
//                       set("selectedBank", null);
//                     } else {
//                       set("selectedBank", JSON.parse(e.target.value));
//                     }
//                   }}
//                   className={inputCls}
//                 >
//                   <option value="">— Select bank account —</option>
//                   {bankList.map((bank, i) => (
//                     <option
//                       key={i}
//                       value={JSON.stringify({
//                         accountNumber: bank.accountNumber,
//                         ifscCode: bank.ifscCode,
//                         branchName: bank.branchName,
//                         branchAddress: bank.branchAddress,
//                       })}
//                     >
//                       {bank.branchName ? `${bank.branchName} — ` : ""}
//                       {bank.accountNumber}
//                     </option>
//                   ))}
//                 </select>
//               )}

//               {/* Bank preview card */}
//               {form.selectedBank && (
//                 <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
//                   <div className="flex items-center gap-2 px-3 py-2 border-b border-blue-100 bg-blue-50">
//                     <RiBankLine className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
//                     <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest">
//                       Selected Bank
//                     </span>
//                   </div>
//                   <div className="px-3 py-2.5 space-y-1.5">
//                     {form.selectedBank.branchName && (
//                       <div className="flex justify-between text-xs">
//                         <span className="text-slate-400 font-medium">
//                           Branch
//                         </span>
//                         <span className="text-slate-700 font-semibold">
//                           {form.selectedBank.branchName}
//                         </span>
//                       </div>
//                     )}
//                     <div className="flex justify-between text-xs">
//                       <span className="text-slate-400 font-medium">
//                         Account No.
//                       </span>
//                       <span className="text-slate-700 font-semibold font-mono">
//                         {form.selectedBank.accountNumber}
//                       </span>
//                     </div>
//                     <div className="flex justify-between text-xs">
//                       <span className="text-slate-400 font-medium">IFSC</span>
//                       <span className="text-slate-700 font-semibold font-mono">
//                         {form.selectedBank.ifscCode}
//                       </span>
//                     </div>
//                     {form.selectedBank.branchAddress && (
//                       <div className="flex justify-between text-xs gap-4">
//                         <span className="text-slate-400 font-medium flex-shrink-0">
//                           Address
//                         </span>
//                         <span className="text-slate-700 text-right">
//                           {form.selectedBank.branchAddress}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* ── Query Contact ── */}
//             <div>
//               <Label>Query Contact</Label>
//               {queryList.length === 0 ? (
//                 <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
//                   <RiInformationLine className="w-4 h-4 flex-shrink-0" />
//                   No query contacts found. Add one in Company Settings.
//                 </div>
//               ) : (
//                 <select
//                   value={
//                     form.selectedQuery
//                       ? JSON.stringify({
//                           contactPersonName:
//                             form.selectedQuery.contactPersonName,
//                           phone: form.selectedQuery.phone,
//                         })
//                       : ""
//                   }
//                   onChange={(e) => {
//                     if (!e.target.value) {
//                       set("selectedQuery", null);
//                     } else {
//                       set("selectedQuery", JSON.parse(e.target.value));
//                     }
//                   }}
//                   className={inputCls}
//                 >
//                   <option value="">— Select query contact —</option>
//                   {queryList.map((q, i) => (
//                     <option
//                       key={i}
//                       value={JSON.stringify({
//                         contactPersonName: q.contactPersonName,
//                         phone: q.phone,
//                       })}
//                     >
//                       {q.contactPersonName}
//                       {q.phone ? ` — ${q.phone}` : ""}
//                     </option>
//                   ))}
//                 </select>
//               )}

//               {/* Query contact preview card */}
//               {form.selectedQuery && (
//                 <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
//                   <div className="flex items-center gap-2 px-3 py-2 border-b border-blue-100 bg-blue-50">
//                     <RiPhoneLine className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
//                     <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest">
//                       Selected Contact
//                     </span>
//                   </div>
//                   <div className="px-3 py-2.5 space-y-1.5">
//                     {form.selectedQuery.contactPersonName && (
//                       <div className="flex justify-between text-xs">
//                         <span className="text-slate-400 font-medium">Name</span>
//                         <span className="text-slate-700 font-semibold">
//                           {form.selectedQuery.contactPersonName}
//                         </span>
//                       </div>
//                     )}
//                     {form.selectedQuery.phone && (
//                       <div className="flex justify-between text-xs">
//                         <span className="text-slate-400 font-medium">
//                           Phone
//                         </span>
//                         <span className="text-slate-700 font-semibold font-mono">
//                           {form.selectedQuery.phone}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* ── Step 4: Items (Combined from all variants) ── */}
//         <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//           <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
//                 4
//               </span>
//               <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Publication Items (All Variants Combined)
//               </span>
//             </div>
//             <span className="text-[10px] text-slate-400 bg-slate-100 px-2 py-1 rounded-full">
//               {totalVariants} RO{totalVariants !== 1 ? "s" : ""}
//             </span>
//           </div>

//           <div className="mx-5 mt-4 flex items-start gap-2 px-3 py-2.5 bg-amber-50 border border-amber-200 rounded-xl text-xs text-amber-700">
//             <RiInformationLine className="w-4 h-4 flex-shrink-0 mt-0.5" />
//             <span>
//               Invoice shows{" "}
//               <strong>
//                 combined items from all {totalVariants} variant(s)
//               </strong>
//               . You can override Width, Height and Rate per item below.
//             </span>
//           </div>

//           <div className="overflow-x-auto mt-4">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="border-b border-blue-100 bg-blue-50/30">
//                   {[
//                     "#",
//                     "RO",
//                     "Publication",
//                     "Edition",
//                     "HUE",
//                     "DOP",
//                     "Page",
//                     "Width (cm)",
//                     "Height (cm)",
//                     "Volume (sq.cm)",
//                     "Rate (₹/sqcm)",
//                     "Amount (₹)",
//                   ].map((h) => (
//                     <th
//                       key={h}
//                       className="px-3 py-2.5 text-left text-[10px] font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap"
//                     >
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {previewItems.map((item, idx) => (
//                   <tr
//                     key={idx}
//                     className="border-b border-blue-50 hover:bg-blue-50/20 transition"
//                   >
//                     <td className="px-3 py-2.5 text-xs text-slate-400 font-mono">
//                       {idx + 1}
//                     </td>
//                     <td className="px-3 py-2.5 text-xs font-bold text-indigo-600 font-mono">
//                       {item.roNumber}
//                     </td>
//                     <td className="px-3 py-2.5 text-xs font-medium text-slate-700">
//                       {item.publication || "—"}
//                     </td>
//                     <td className="px-3 py-2.5 text-xs text-slate-500">
//                       {item.edition || "—"}
//                     </td>
//                     <td className="px-3 py-2.5 text-xs text-slate-500">
//                       {item.hue}
//                     </td>
//                     <td className="px-3 py-2.5 text-xs text-slate-500 whitespace-nowrap">
//                       {item.dop || "—"}
//                     </td>
//                     <td className="px-2 py-1.5">
//                       <input
//                         type="number"
//                         min="0"
//                         value={itemEdits[idx]?.page ?? ""}
//                         onChange={(e) =>
//                           updateItemEdit(idx, "page", e.target.value)
//                         }
//                         className="w-14 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
//                         placeholder="0"
//                       />
//                     </td>
//                     <td className="px-2 py-1.5">
//                       <input
//                         type="number"
//                         min="0"
//                         step="0.1"
//                         value={itemEdits[idx]?.width ?? ""}
//                         onChange={(e) =>
//                           updateItemEdit(idx, "width", e.target.value)
//                         }
//                         className="w-16 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
//                         placeholder={String(item.width)}
//                       />
//                     </td>
//                     <td className="px-2 py-1.5">
//                       <input
//                         type="number"
//                         min="0"
//                         step="0.1"
//                         value={itemEdits[idx]?.height ?? ""}
//                         onChange={(e) =>
//                           updateItemEdit(idx, "height", e.target.value)
//                         }
//                         className="w-16 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
//                         placeholder={String(item.height)}
//                       />
//                     </td>
//                     <td className="px-3 py-2.5 text-xs text-left font-mono font-semibold text-slate-700">
//                       {item.volume?.toFixed(2)}
//                     </td>
//                     <td className="px-2 py-1.5">
//                       <input
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         value={itemEdits[idx]?.rate ?? ""}
//                         onChange={(e) =>
//                           updateItemEdit(idx, "rate", e.target.value)
//                         }
//                         className="w-20 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
//                         placeholder={String(item.rate)}
//                       />
//                     </td>
//                     <td className="px-3 py-2.5 text-xs text-left font-bold text-blue-700 font-mono whitespace-nowrap">
//                       ₹{fmtNum(item.amount)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="px-5 py-3 border-t border-blue-50">
//             <span className="text-xs font-semibold text-slate-600">
//               HSN Code —{" "}
//             </span>
//             <span className="text-xs font-bold text-slate-800 font-mono">
//               {form.hsnCode}
//             </span>
//           </div>
//         </div>

//         {/* ── Step 5: GST & Amount Summary ── */}
//         <div className="flex justify-end">
//           <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden w-full max-w-sm">
//             <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center gap-2">
//               <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
//                 5
//               </span>
//               <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Amount Summary
//               </span>
//             </div>

//             <div className="p-5 space-y-3 text-sm">
//               <div className="flex justify-between py-1.5 border-b border-blue-50">
//                 <span className="text-slate-600 font-medium">Sub Total</span>
//                 <span className="font-bold text-slate-800 font-mono">
//                   ₹{fmtNum(subTotal)}
//                 </span>
//               </div>

//               {/* CGST */}
//               <div className="flex items-center gap-2">
//                 <span className="text-slate-500 text-xs flex-1">CGST</span>
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-xs text-slate-400">(</span>
//                   <input
//                     type="number"
//                     min="0"
//                     max="50"
//                     step="0.5"
//                     value={form.cgstRate}
//                     onChange={(e) => set("cgstRate", e.target.value)}
//                     className="w-12 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
//                   />
//                   <span className="text-xs text-blue-400">%)</span>
//                   <span className="font-semibold text-emerald-600 font-mono text-xs w-24 text-right">
//                     ₹{fmtNum(cgstAmt)}
//                   </span>
//                 </div>
//               </div>

//               {/* SGST */}
//               <div className="flex items-center gap-2">
//                 <span className="text-slate-500 text-xs flex-1">SGST</span>
//                 <div className="flex items-center gap-1.5">
//                   <span className="text-xs text-slate-400">(</span>
//                   <input
//                     type="number"
//                     min="0"
//                     max="50"
//                     step="0.5"
//                     value={form.sgstRate}
//                     onChange={(e) => set("sgstRate", e.target.value)}
//                     className="w-12 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
//                   />
//                   <span className="text-xs text-blue-400">%)</span>
//                   <span className="font-semibold text-emerald-600 font-mono text-xs w-24 text-right">
//                     ₹{fmtNum(sgstAmt)}
//                   </span>
//                 </div>
//               </div>

//               {/* Total */}
//               <div className="flex items-center justify-between pt-3 border-t-2 border-indigo-600/20">
//                 <span className="text-indigo-800 font-bold text-sm">TOTAL</span>
//                 <span className="font-extrabold text-indigo-700 text-lg font-mono">
//                   ₹{fmtNum(total)}
//                 </span>
//               </div>

//               {/* Amount in words */}
//               {total > 0 && (
//                 <div className="mt-2 px-3 py-2 bg-slate-50 border border-slate-100 rounded-lg">
//                   <div className="text-[10px] text-slate-400 uppercase tracking-widest mb-0.5">
//                     Amount in words
//                   </div>
//                   <div className="text-xs font-semibold text-slate-700 italic">
//                     Rupees {amtWords}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* ── Action Buttons ── */}
//         <div className="flex justify-end gap-3 flex-wrap">
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center gap-1.5 px-6 py-2.5 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 font-semibold transition"
//           >
//             <RiArrowLeftLine className="w-4 h-4" /> Cancel
//           </button>

//           <button
//             onClick={handleDownloadPDF}
//             className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold border border-indigo-200 text-indigo-600 hover:bg-indigo-50 transition"
//           >
//             <RiDownload2Line className="w-4 h-4" /> Download PDF
//           </button>

//           <button
//             onClick={handleSubmit}
//             disabled={submitting}
//             className="flex items-center gap-2 px-7 py-2.5 rounded-xl text-sm font-bold bg-indigo-600 hover:bg-indigo-700 text-white transition shadow-lg shadow-indigo-200 disabled:opacity-60"
//           >
//             {submitting ? <Spinner /> : <RiCheckLine className="w-4 h-4" />}
//             {submitting ? "Creating…" : "Create Invoice"}
//           </button>
//         </div>
//       </div>

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  RiFileTextLine,
  RiCheckLine,
  RiErrorWarningLine,
  RiCloseLine,
  RiCalendarLine,
  RiArrowLeftLine,
  RiInformationLine,
  RiPrinterLine,
  RiBuildingLine,
  RiUserLine,
  RiShieldLine,
  RiDownload2Line,
  RiBankLine,
  RiPhoneLine,
  RiAdvertisementLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { generateInvoicePDF } from "../Util/GenerateInvoicePDF";

const BASE_URL = process.env.REACT_APP_API_URL;

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const fmtNum = (n) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const Label = ({ children }) => (
  <label className="text-[10px] font-semibold text-blue-600 uppercase tracking-widest mb-1 block">
    {children}
  </label>
);

const inputCls =
  "w-full bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition";

const defaultForm = {
  invoiceNumber: "",
  date: "",
  pan: "",
  gstNumber: "",
  customerId: "",
  hsnCode: "998363",
  cgstRate: 2.5,
  sgstRate: 2.5,
  notes: "",
  remark1: "",
  remark2: "",
  remark3: "",
  splitBillAttached: false,
  selectedBank: null,
  selectedQuery: null,
  advertisingTypeId: "",
  discountType: "",
  discountValue: 0,
  billTo: {
    name: "",
    company: "",
    address: "",
    phone: "",
    gstNumber: "",
  },
};

const ROInfoBadge = ({ label, value, icon: Icon }) => (
  <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2">
    {Icon && <Icon className="w-3.5 h-3.5 text-blue-400 flex-shrink-0" />}
    <div className="min-w-0">
      <div className="text-[9px] font-bold text-blue-400 uppercase tracking-widest">
        {label}
      </div>
      <div className="text-xs font-semibold text-slate-700 truncate">
        {value || "—"}
      </div>
    </div>
  </div>
);

// ── amount-in-words ────────────────────────────────────────────────────────
const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];
const tens = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];
function numToWords(n) {
  n = Math.round(n);
  if (n === 0) return "Zero";
  if (n < 0) return "Minus " + numToWords(-n);
  if (n < 20) return ones[n];
  if (n < 100)
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  if (n < 1000)
    return (
      ones[Math.floor(n / 100)] +
      " Hundred" +
      (n % 100 ? " " + numToWords(n % 100) : "")
    );
  if (n < 100000)
    return (
      numToWords(Math.floor(n / 1000)) +
      " Thousand" +
      (n % 1000 ? " " + numToWords(n % 1000) : "")
    );
  if (n < 10000000)
    return (
      numToWords(Math.floor(n / 100000)) +
      " Lakh" +
      (n % 100000 ? " " + numToWords(n % 100000) : "")
    );
  return (
    numToWords(Math.floor(n / 10000000)) +
    " Crore" +
    (n % 10000000 ? " " + numToWords(n % 10000000) : "")
  );
}

export default function CreateInvoiceByReleaseOrder() {
  const { part1, part2, part3 } = useParams();
  const baseRONumber = `${part1}/${part2}/${part3}`;
  const navigate = useNavigate();

  const [roGroup, setRoGroup] = useState(null);
  const [form, setForm] = useState(defaultForm);
  const [itemEdits, setItemEdits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState(null);
  const [saved, setSaved] = useState(null);
  const [company, setCompany] = useState({});
  const [bankList, setBankList] = useState([]);
  const [queryList, setQueryList] = useState([]);
  const [advertisingTypes, setAdvertisingTypes] = useState([]); // ← new

  const isAxisBank = form.billTo?.company?.toLowerCase().includes("axis bank");

  const [axisForm, setAxisForm] = useState({
    city: "",
    product: "",
    typesOfLegalAuction: "",
    natureOfExpenses: "",
    courtCaseNumber: "",
    noOfCases: 0,
    ratePerCase: 0,
  });
  const setAxis = (key, val) => setAxisForm((f) => ({ ...f, [key]: val }));

  const notify = (message, type = "success") => setToast({ message, type });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [roRes, companyRes, advTypesRes] = await Promise.allSettled([
          axios.get(
            `${BASE_URL}/releaseOrder/release-orders/base/${baseRONumber}`,
          ),
          axios.get(`${BASE_URL}/company/get`),
          axios.get(`${BASE_URL}/quotation-advertising-type`), // ← new
        ]);

        if (roRes.status === "fulfilled") {
          const roData = roRes.value?.data?.data || roRes.value?.data;
          setRoGroup(roData);

          const allItems =
            roData.variants?.flatMap((v) => v.items || []) ||
            roData.items ||
            [];

          const edits = allItems.map((item) => ({
            width: item.width ?? "",
            height: item.height ?? "",
            rate: item.ratePerSqCm || item.rate || "",
            page: String(item.pagePosition || ""),
          }));
          setItemEdits(edits);

          setForm((f) => ({
            ...f,
            baseRONumber: baseRONumber,
            billTo: {
              name: roData.client?.contactPerson || roData.client?.name || "",
              company: roData.client?.bankName || "",
              address: roData.client?.address || "",
              phone: roData.client?.phone || "",
              gstNumber: roData.client?.gstno || roData.client?.gstNumber || "",
            },
            customerId: roData.client?.customer_id || "",
          }));

          try {
            const invRes = await axios.get(
              `${BASE_URL}/invoice/getInvoiceNumber/${baseRONumber}`,
            );
            const d = invRes.data?.data;
            if (d?.invoiceNumber) {
              setForm((f) => ({
                ...f,
                invoiceNumber: d.invoiceNumber,
                date: d.invoiceDate || f.date,
              }));
            }
          } catch (invError) {
            console.log("Could not fetch invoice number:", invError);
          }
        } else {
          notify("Failed to load release order", "error");
        }

        if (companyRes.status === "fulfilled") {
          const companyData =
            companyRes.value?.data?.data || companyRes.value?.data;
          setCompany(companyData);

          const banks = companyData?.bankDetails || [];
          const queries = companyData?.queryDetails || [];
          setBankList(banks);
          setQueryList(queries);

          setForm((f) => ({
            ...f,
            pan: f.pan || companyData?.pan || "",
            gstNumber: f.gstNumber || companyData?.gst || "",
            selectedBank: banks.length > 0 ? banks[0] : null,
            selectedQuery: queries.length > 0 ? queries[0] : null,
          }));
        }

        // ── Advertising types ──────────────────────────────────────────────
        if (advTypesRes.status === "fulfilled") {
          const types =
            advTypesRes.value?.data?.data || advTypesRes.value?.data || [];
          setAdvertisingTypes(types);
        }
        // A failure here is non-critical; the field will just be empty.
      } catch (error) {
        console.error("Error fetching data:", error);
        notify("Failed to load data", "error");
      } finally {
        setLoading(false);
      }
    };

    if (baseRONumber) fetchData();
  }, [baseRONumber]);

  const set = (key, val) => setForm((f) => ({ ...f, [key]: val }));
  const setBillTo = (key, val) =>
    setForm((f) => ({ ...f, billTo: { ...f.billTo, [key]: val } }));

  const updateItemEdit = (idx, field, val) =>
    setItemEdits((prev) =>
      prev.map((e, i) => (i === idx ? { ...e, [field]: val } : e)),
    );

  const previewItems = roGroup
    ? (roGroup.variants?.flatMap((v) => v.items) || roGroup.items || []).map(
        (item, idx) => {
          const edit = itemEdits[idx] || {};
          const width =
            edit.width !== "" ? Number(edit.width) : item.width || 0;
          const height =
            edit.height !== "" ? Number(edit.height) : item.height || 0;
          const rate =
            edit.rate !== ""
              ? Number(edit.rate)
              : item.ratePerSqCm || item.rate || 0;
          const volume = width * height;
          const amount = volume * rate;
          return {
            roNumber: item.roNumber || "—",
            publication: item.publication || "",
            edition: item.edition || "",
            hue: item.hue || "B/W",
            dop: item.dop ? new Date(item.dop).toLocaleDateString("en-IN") : "",
            pagePosition: item.pagePosition || "",
            page:
              itemEdits[idx]?.page !== undefined && itemEdits[idx]?.page !== ""
                ? itemEdits[idx].page
                : item.pagePosition || "",
            width,
            height,
            volume,
            rate,
            amount,
          };
        },
      )
    : [];

  const subTotal = previewItems.reduce((s, i) => s + i.amount, 0);

  // Discount calculation (non-axis)
  const calculateDiscountAmount = () => {
    if (!form.discountType || !form.discountValue || form.discountValue <= 0)
      return 0;
    if (form.discountType === "percentage")
      return (subTotal * form.discountValue) / 100;
    if (form.discountType === "fixed")
      return Math.min(form.discountValue, subTotal);
    return 0;
  };
  const discountAmount = calculateDiscountAmount();
  const taxableAmount = subTotal - discountAmount;
  const cgstAmt = (taxableAmount * Number(form.cgstRate || 0)) / 100;
  const sgstAmt = (taxableAmount * Number(form.sgstRate || 0)) / 100;
  const total = taxableAmount + cgstAmt + sgstAmt;

  // Axis bank calculation
  const axisAmount = (axisForm.noOfCases || 0) * (axisForm.ratePerCase || 0);
  const axisCgst = axisAmount * 0.025;
  const axisSgst = axisAmount * 0.025;
  const axisTotal = axisAmount + axisCgst + axisSgst;

  const finalTotal = isAxisBank ? axisTotal : total;
  const amtWords = numToWords(Math.round(finalTotal)) + " Only";

  const handleSubmit = async () => {
    if (!form.invoiceNumber)
      return notify("Invoice number is required", "error");

    setSubmitting(true);
    try {
      const itemOverridesWithPage = itemEdits.map((edit) => ({
        ...edit,
        page: edit.page || "",
      }));

      const payload = {
        ...form,
        baseRONumber: baseRONumber,
        itemOverrides: itemOverridesWithPage,
        advertisingTypeId: form.advertisingTypeId || null,
        discountType: form.discountType || null, // ← ADD THIS
        discountValue: form.discountValue || 0, // ← ADD THIS
        axisBankDetails: isAxisBank ? axisForm : null,
      };

      const res = await axios.post(`${BASE_URL}/invoice/create`, payload);
      const createdInvoice = res.data?.data || res.data;

      setSaved(createdInvoice);
      notify("Invoice created successfully for all variants!");
      setTimeout(() => {
        navigate(`/admin/all-invoice`);
      }, 2000);
    } catch (err) {
      console.error("Invoice creation error:", err);
      notify(
        err?.response?.data?.message || "Failed to create invoice",
        "error",
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleDownloadPDF = () => {
    const invoiceData = {
      invoiceNumber: form.invoiceNumber,
      date: form.date,
      pan: form.pan,
      gstNumber: form.gstNumber,
      customerId: form.customerId,
      hsnCode: form.hsnCode,
      remark1: form.remark1,
      remark2: form.remark2,
      remark3: form.remark3,
      splitBillAttached: form.splitBillAttached,
      cgstRate: Number(form.cgstRate),
      sgstRate: Number(form.sgstRate),
      cgstAmount: cgstAmt,
      sgstAmount: sgstAmt,
      subTotal,
      totalAmount: total,
      amountInWords: amtWords,
      billTo: form.billTo,
      items: previewItems,
      company,
      selectedBank: form.selectedBank,
      selectedQuery: form.selectedQuery,
      advertisingType:
        advertisingTypes.find((t) => t._id === form.advertisingTypeId) || null,
    };

    generateInvoicePDF(invoiceData);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 text-blue-400">
          <Spinner className="w-10 h-10" />
          <span className="text-sm font-medium">Loading release order…</span>
        </div>
      </div>
    );
  }

  if (!roGroup) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <RiErrorWarningLine className="w-12 h-12 text-red-400 mx-auto mb-3" />
          <p className="text-slate-600 font-semibold mb-4">
            Release order not found.
          </p>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold mx-auto"
          >
            <RiArrowLeftLine className="w-4 h-4" /> Go Back
          </button>
        </div>
      </div>
    );
  }

  const totalVariants = roGroup.variants?.length || 1;
  const totalItems =
    roGroup.variants?.reduce((sum, v) => sum + (v.items?.length || 0), 0) || 0;

  // Resolved label for the selected advertising type
  const selectedAdvTypeName =
    advertisingTypes.find((t) => t._id === form.advertisingTypeId)?.name || "";

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* ── Header ── */}
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-700 hover:bg-blue-50 transition"
            >
              <RiArrowLeftLine className="w-4 h-4" />
            </button>
            <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-md shadow-indigo-200">
              <RiPrinterLine className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-indigo-800 tracking-tight">
                Create Invoice
              </h1>
              <p className="text-[11px] text-indigo-400 tracking-widest uppercase">
                {totalVariants} variant{totalVariants !== 1 ? "s" : ""} •{" "}
                {totalItems} items
              </p>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <ROInfoBadge
              label="Base RO"
              value={baseRONumber}
              icon={RiFileTextLine}
            />
            <ROInfoBadge
              label="Client"
              value={roGroup?.client?.bankName}
              icon={RiBuildingLine}
            />
            <ROInfoBadge
              label="Variants"
              value={`${totalVariants}`}
              icon={RiUserLine}
            />
          </div>
        </div>
      </header>

      <div className="px-6 py-6 pb-24 mx-auto space-y-5 w-full">
        {/* ── RO Summary Banner ── */}
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl p-5 text-white shadow-lg shadow-indigo-200/50">
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div>
              <div className="text-indigo-200 text-[10px] font-bold uppercase tracking-widest mb-1">
                Base Release Order
              </div>
              <div className="text-xl font-extrabold tracking-tight mb-1">
                {baseRONumber}
              </div>
              <div className="text-indigo-200 text-sm">
                {totalVariants} variant{totalVariants !== 1 ? "s" : ""} combined
              </div>
            </div>
            <div className="flex flex-col items-end gap-1">
              <div className="text-indigo-200 text-[10px] font-bold uppercase tracking-widest">
                Total Items
              </div>
              <div className="text-3xl font-extrabold">{totalItems}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 mt-4 pt-4 border-t border-indigo-500/40 md:hidden flex-wrap">
            <span className="text-xs text-indigo-200">
              <span className="font-semibold text-white">Client: </span>
              {roGroup.client?.bankName}
            </span>
            <span className="text-xs text-indigo-200">
              <span className="font-semibold text-white">Variants: </span>
              {totalVariants}
            </span>
          </div>
        </div>

        {/* ── Step 1: Invoice Details ── */}
        <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center gap-2">
            <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
              1
            </span>
            <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
              Invoice Details
            </span>
          </div>

          <div className="p-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <div>
              <Label>Invoice Number</Label>
              <input
                value={form.invoiceNumber}
                onChange={(e) => set("invoiceNumber", e.target.value)}
                className={inputCls}
                placeholder="e.g. NG/1137/25-26"
              />
            </div>
            <div>
              <Label>Date</Label>
              <div className="relative">
                <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
                <input
                  type="date"
                  value={form.date}
                  onChange={(e) => set("date", e.target.value)}
                  className={`${inputCls} pl-9`}
                />
              </div>
            </div>
            <div>
              <Label>PAN</Label>
              <input
                value={form.pan}
                onChange={(e) => set("pan", e.target.value)}
                className={inputCls}
                placeholder="ALBPD0451G"
              />
            </div>
            <div>
              <Label>Our GST No.</Label>
              <input
                value={form.gstNumber}
                onChange={(e) => set("gstNumber", e.target.value)}
                className={inputCls}
                placeholder="21ALBPD0451G2Z0"
              />
            </div>
            <div>
              <Label>Customer ID</Label>
              <input
                value={form.customerId}
                onChange={(e) => set("customerId", e.target.value)}
                className={inputCls}
                placeholder="UBI/BALASORE"
              />
            </div>
            <div>
              <Label>HSN Code</Label>
              <input
                value={form.hsnCode}
                onChange={(e) => set("hsnCode", e.target.value)}
                className={inputCls}
                placeholder="998363"
              />
            </div>

            {/* ── Advertising Type (new) ── */}
            <div>
              <Label>Advertising Type</Label>
              {advertisingTypes.length === 0 ? (
                <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
                  <RiInformationLine className="w-4 h-4 flex-shrink-0" />
                  No advertising types found. Add one in Settings.
                </div>
              ) : (
                <div className="relative">
                  <RiAdvertisementLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
                  <select
                    value={form.advertisingTypeId}
                    onChange={(e) => set("advertisingTypeId", e.target.value)}
                    className={`${inputCls} pl-9 appearance-none`}
                  >
                    <option value="">— Select advertising type —</option>
                    {advertisingTypes.map((type) => (
                      <option key={type._id} value={type._id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Preview badge when a type is selected */}
              {selectedAdvTypeName && (
                <div className="mt-1.5 flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 border border-indigo-100 rounded-lg w-fit">
                  <RiAdvertisementLine className="w-3 h-3 text-indigo-400" />
                  <span className="text-[11px] font-semibold text-indigo-600">
                    {selectedAdvTypeName}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Step 2: Bill To ── */}
        <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
                2
              </span>
              <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Bill To
              </span>
            </div>
            <span className="text-[10px] text-indigo-400 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-full font-semibold">
              Pre-filled from RO client
            </span>
          </div>
          <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <Label>Name / Designation</Label>
              <input
                value={form.billTo.name}
                onChange={(e) => setBillTo("name", e.target.value)}
                className={inputCls}
                placeholder="The Regional Manager"
              />
            </div>
            <div>
              <Label>Company / Bank</Label>
              <input
                value={form.billTo.company}
                onChange={(e) => setBillTo("company", e.target.value)}
                className={inputCls}
                placeholder="Union Bank of India"
              />
            </div>
            <div className="col-span-full">
              <Label>Address</Label>
              <input
                value={form.billTo.address}
                onChange={(e) => setBillTo("address", e.target.value)}
                className={inputCls}
                placeholder="Manikhambu, OT Road, Police Line…"
              />
            </div>
            <div>
              <Label>Phone No.</Label>
              <input
                value={form.billTo.phone}
                onChange={(e) => setBillTo("phone", e.target.value)}
                className={inputCls}
                placeholder="Phone"
              />
            </div>
            <div>
              <Label>GST No. (Client)</Label>
              <div className="relative">
                <RiShieldLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
                <input
                  value={form.billTo.gstNumber}
                  onChange={(e) => setBillTo("gstNumber", e.target.value)}
                  className={`${inputCls} pl-9`}
                  placeholder="21AAACUØ564G2ZS"
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── Step 3: Bank Account & Query Contact ── */}
        <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
                3
              </span>
              <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Payment & Contact Details
              </span>
            </div>
            <span className="text-[10px] text-indigo-400 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-full font-semibold">
              Shown on invoice
            </span>
          </div>

          <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {/* ── Bank Account ── */}
            <div>
              <Label>Bank Account</Label>
              {bankList.length === 0 ? (
                <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
                  <RiInformationLine className="w-4 h-4 flex-shrink-0" />
                  No bank accounts found. Add one in Company Settings.
                </div>
              ) : (
                <select
                  value={
                    form.selectedBank
                      ? JSON.stringify({
                          accountNumber: form.selectedBank.accountNumber,
                          ifscCode: form.selectedBank.ifscCode,
                          branchName: form.selectedBank.branchName,
                          branchAddress: form.selectedBank.branchAddress,
                        })
                      : ""
                  }
                  onChange={(e) => {
                    if (!e.target.value) {
                      set("selectedBank", null);
                    } else {
                      set("selectedBank", JSON.parse(e.target.value));
                    }
                  }}
                  className={inputCls}
                >
                  <option value="">— Select bank account —</option>
                  {bankList.map((bank, i) => (
                    <option
                      key={i}
                      value={JSON.stringify({
                        accountNumber: bank.accountNumber,
                        ifscCode: bank.ifscCode,
                        branchName: bank.branchName,
                        branchAddress: bank.branchAddress,
                      })}
                    >
                      {bank.branchName ? `${bank.branchName} — ` : ""}
                      {bank.accountNumber}
                    </option>
                  ))}
                </select>
              )}

              {form.selectedBank && (
                <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
                  <div className="flex items-center gap-2 px-3 py-2 border-b border-blue-100 bg-blue-50">
                    <RiBankLine className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
                    <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest">
                      Selected Bank
                    </span>
                  </div>
                  <div className="px-3 py-2.5 space-y-1.5">
                    {form.selectedBank.branchName && (
                      <div className="flex justify-between text-xs">
                        <span className="text-slate-400 font-medium">
                          Branch
                        </span>
                        <span className="text-slate-700 font-semibold">
                          {form.selectedBank.branchName}
                        </span>
                      </div>
                    )}
                    <div className="flex justify-between text-xs">
                      <span className="text-slate-400 font-medium">
                        Account No.
                      </span>
                      <span className="text-slate-700 font-semibold font-mono">
                        {form.selectedBank.accountNumber}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs">
                      <span className="text-slate-400 font-medium">IFSC</span>
                      <span className="text-slate-700 font-semibold font-mono">
                        {form.selectedBank.ifscCode}
                      </span>
                    </div>
                    {form.selectedBank.branchAddress && (
                      <div className="flex justify-between text-xs gap-4">
                        <span className="text-slate-400 font-medium flex-shrink-0">
                          Address
                        </span>
                        <span className="text-slate-700 text-right">
                          {form.selectedBank.branchAddress}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* ── Query Contact ── */}
            <div>
              <Label>Query Contact</Label>
              {queryList.length === 0 ? (
                <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
                  <RiInformationLine className="w-4 h-4 flex-shrink-0" />
                  No query contacts found. Add one in Company Settings.
                </div>
              ) : (
                <select
                  value={
                    form.selectedQuery
                      ? JSON.stringify({
                          contactPersonName:
                            form.selectedQuery.contactPersonName,
                          phone: form.selectedQuery.phone,
                        })
                      : ""
                  }
                  onChange={(e) => {
                    if (!e.target.value) {
                      set("selectedQuery", null);
                    } else {
                      set("selectedQuery", JSON.parse(e.target.value));
                    }
                  }}
                  className={inputCls}
                >
                  <option value="">— Select query contact —</option>
                  {queryList.map((q, i) => (
                    <option
                      key={i}
                      value={JSON.stringify({
                        contactPersonName: q.contactPersonName,
                        phone: q.phone,
                      })}
                    >
                      {q.contactPersonName}
                      {q.phone ? ` — ${q.phone}` : ""}
                    </option>
                  ))}
                </select>
              )}

              {form.selectedQuery && (
                <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
                  <div className="flex items-center gap-2 px-3 py-2 border-b border-blue-100 bg-blue-50">
                    <RiPhoneLine className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
                    <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest">
                      Selected Contact
                    </span>
                  </div>
                  <div className="px-3 py-2.5 space-y-1.5">
                    {form.selectedQuery.contactPersonName && (
                      <div className="flex justify-between text-xs">
                        <span className="text-slate-400 font-medium">Name</span>
                        <span className="text-slate-700 font-semibold">
                          {form.selectedQuery.contactPersonName}
                        </span>
                      </div>
                    )}
                    {form.selectedQuery.phone && (
                      <div className="flex justify-between text-xs">
                        <span className="text-slate-400 font-medium">
                          Phone
                        </span>
                        <span className="text-slate-700 font-semibold font-mono">
                          {form.selectedQuery.phone}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Step 4: Items (Combined from all variants) ── */}
        {!isAxisBank && (
          <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
                  4
                </span>
                <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                  Publication Items (All Variants Combined)
                </span>
              </div>
              <span className="text-[10px] text-slate-400 bg-slate-100 px-2 py-1 rounded-full">
                {totalVariants} RO{totalVariants !== 1 ? "s" : ""}
              </span>
            </div>

            <div className="mx-5 mt-4 flex items-start gap-2 px-3 py-2.5 bg-amber-50 border border-amber-200 rounded-xl text-xs text-amber-700">
              <RiInformationLine className="w-4 h-4 flex-shrink-0 mt-0.5" />
              <span>
                Invoice shows{" "}
                <strong>
                  combined items from all {totalVariants} variant(s)
                </strong>
                . You can override Width, Height and Rate per item below.
              </span>
            </div>

            <div className="overflow-x-auto mt-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-blue-100 bg-blue-50/30">
                    {[
                      "#",
                      "RO",
                      "Publication",
                      "Edition",
                      "HUE",
                      "DOP",
                      "Page",
                      "Width (cm)",
                      "Height (cm)",
                      "Volume (sq.cm)",
                      "Rate (₹/sqcm)",
                      "Amount (₹)",
                    ].map((h) => (
                      <th
                        key={h}
                        className="px-3 py-2.5 text-left text-[10px] font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {previewItems.map((item, idx) => (
                    <tr
                      key={idx}
                      className="border-b border-blue-50 hover:bg-blue-50/20 transition"
                    >
                      <td className="px-3 py-2.5 text-xs text-slate-400 font-mono">
                        {idx + 1}
                      </td>
                      <td className="px-3 py-2.5 text-xs font-bold text-indigo-600 font-mono">
                        {item.roNumber}
                      </td>
                      <td className="px-3 py-2.5 text-xs font-medium text-slate-700">
                        {item.publication || "—"}
                      </td>
                      <td className="px-3 py-2.5 text-xs text-slate-500">
                        {item.edition || "—"}
                      </td>
                      <td className="px-3 py-2.5 text-xs text-slate-500">
                        {item.hue}
                      </td>
                      <td className="px-3 py-2.5 text-xs text-slate-500 whitespace-nowrap">
                        {item.dop || "—"}
                      </td>
                      <td className="px-2 py-1.5">
                        <input
                          type="number"
                          min="0"
                          value={itemEdits[idx]?.page ?? ""}
                          onChange={(e) =>
                            updateItemEdit(idx, "page", e.target.value)
                          }
                          className="w-14 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
                          placeholder="0"
                        />
                      </td>
                      <td className="px-2 py-1.5">
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          value={itemEdits[idx]?.width ?? ""}
                          onChange={(e) =>
                            updateItemEdit(idx, "width", e.target.value)
                          }
                          className="w-16 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
                          placeholder={String(item.width)}
                        />
                      </td>
                      <td className="px-2 py-1.5">
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          value={itemEdits[idx]?.height ?? ""}
                          onChange={(e) =>
                            updateItemEdit(idx, "height", e.target.value)
                          }
                          className="w-16 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
                          placeholder={String(item.height)}
                        />
                      </td>
                      <td className="px-3 py-2.5 text-xs text-left font-mono font-semibold text-slate-700">
                        {item.volume?.toFixed(2)}
                      </td>
                      <td className="px-2 py-1.5">
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={itemEdits[idx]?.rate ?? ""}
                          onChange={(e) =>
                            updateItemEdit(idx, "rate", e.target.value)
                          }
                          className="w-20 text-center border border-blue-200 rounded-lg py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500 transition"
                          placeholder={String(item.rate)}
                        />
                      </td>
                      <td className="px-3 py-2.5 text-xs text-left font-bold text-blue-700 font-mono whitespace-nowrap">
                        ₹{fmtNum(item.amount)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="px-5 py-3 border-t border-blue-50">
              <span className="text-xs font-semibold text-slate-600">
                HSN Code —{" "}
              </span>
              <span className="text-xs font-bold text-slate-800 font-mono">
                {form.hsnCode}
              </span>
            </div>
          </div>
        )}

        {isAxisBank && (
          <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
                4
              </span>
              <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Axis Bank Details
              </span>
            </div>
            <div className="p-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <div>
                <Label>City</Label>
                <input
                  value={axisForm.city}
                  onChange={(e) => setAxis("city", e.target.value)}
                  className={inputCls}
                  placeholder="City"
                />
              </div>
              <div>
                <Label>Product</Label>
                <input
                  value={axisForm.product}
                  onChange={(e) => setAxis("product", e.target.value)}
                  className={inputCls}
                  placeholder="Product"
                />
              </div>
              <div>
                <Label>Types of Legal Auction</Label>
                <input
                  value={axisForm.typesOfLegalAuction}
                  onChange={(e) =>
                    setAxis("typesOfLegalAuction", e.target.value)
                  }
                  className={inputCls}
                  placeholder="Types of Legal Auction"
                />
              </div>
              <div>
                <Label>Nature of Expenses</Label>
                <input
                  value={axisForm.natureOfExpenses}
                  onChange={(e) => setAxis("natureOfExpenses", e.target.value)}
                  className={inputCls}
                  placeholder="Nature of Expenses"
                />
              </div>
              <div>
                <Label>Court Case Number</Label>
                <input
                  value={axisForm.courtCaseNumber}
                  onChange={(e) => setAxis("courtCaseNumber", e.target.value)}
                  className={inputCls}
                  placeholder="Court Case Number"
                />
              </div>
              <div>
                <Label>No. of Cases</Label>
                <input
                  type="number"
                  min="0"
                  value={axisForm.noOfCases}
                  onChange={(e) => setAxis("noOfCases", Number(e.target.value))}
                  className={inputCls}
                  placeholder="0"
                />
              </div>
              <div>
                <Label>Rate per Case (₹)</Label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={axisForm.ratePerCase}
                  onChange={(e) =>
                    setAxis("ratePerCase", Number(e.target.value))
                  }
                  className={inputCls}
                  placeholder="0.00"
                />
              </div>
            </div>
          </div>
        )}

        {/* ── step:5 Remarks ── */}
        <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center gap-2">
            <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
              5
            </span>
            <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
              Remarks
            </span>
          </div>

          <div className="p-5 space-y-4">
            <div>
              <Label>Remark 1</Label>
              <textarea
                rows={2}
                value={form.remark1}
                onChange={(e) => set("remark1", e.target.value)}
                className={inputCls}
                placeholder="Enter remark 1"
              />
            </div>

            <div>
              <Label>Remark 2</Label>
              <textarea
                rows={2}
                value={form.remark2}
                onChange={(e) => set("remark2", e.target.value)}
                className={inputCls}
                placeholder="Enter remark 2"
              />
            </div>

            <div>
              <Label>Remark 3</Label>
              <textarea
                rows={2}
                value={form.remark3}
                onChange={(e) => set("remark3", e.target.value)}
                className={inputCls}
                placeholder="Enter remark 3"
              />
            </div>
          </div>

          <div className="border-t border-blue-100 p-4">
            <Label>Split Bill Attached</Label>

            <button
              type="button"
              onClick={() => set("splitBillAttached", !form.splitBillAttached)}
              className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors ${
                form.splitBillAttached ? "bg-green-500" : "bg-slate-300"
              }`}
            >
              <span
                className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                  form.splitBillAttached ? "translate-x-8" : "translate-x-1"
                }`}
              />
            </button>

            <span className="ml-3 text-sm font-medium text-slate-700">
              {form.splitBillAttached ? "Yes" : "No"}
            </span>
          </div>
        </div>

        {/* ── Step 6: GST, Discount & Amount Summary ── */}
        <div className="flex justify-end">
          <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden w-full max-w-sm">
            <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
                6
              </span>
              <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Amount Summary
              </span>
            </div>

            {isAxisBank ? (
              <div className="p-5 space-y-3 text-sm">
                <div className="flex justify-between py-1.5 border-b border-blue-50">
                  <span className="text-slate-600 font-medium">
                    No. of Cases × Rate
                  </span>
                  <span className="font-bold text-slate-800 font-mono">
                    ₹{fmtNum(axisAmount)}
                  </span>
                </div>
                <div className="flex justify-between py-1.5">
                  <span className="text-slate-500 text-xs">CGST (2.5%)</span>
                  <span className="font-semibold text-emerald-600 font-mono text-xs">
                    ₹{fmtNum(axisCgst)}
                  </span>
                </div>
                <div className="flex justify-between py-1.5 border-b border-blue-50">
                  <span className="text-slate-500 text-xs">SGST (2.5%)</span>
                  <span className="font-semibold text-emerald-600 font-mono text-xs">
                    ₹{fmtNum(axisSgst)}
                  </span>
                </div>
                <div className="flex items-center justify-between pt-3 border-t-2 border-indigo-600/20">
                  <span className="text-indigo-800 font-bold text-sm">
                    TOTAL
                  </span>
                  <span className="font-extrabold text-indigo-700 text-lg font-mono">
                    ₹{fmtNum(axisTotal)}
                  </span>
                </div>
                {axisTotal > 0 && (
                  <div className="mt-2 px-3 py-2 bg-slate-50 border border-slate-100 rounded-lg">
                    <div className="text-[10px] text-slate-400 uppercase tracking-widest mb-0.5">
                      Amount in words
                    </div>
                    <div className="text-xs font-semibold text-slate-700 italic">
                      Rupees {amtWords}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="p-5 space-y-3 text-sm">
                <div className="flex justify-between py-1.5 border-b border-blue-50">
                  <span className="text-slate-600 font-medium">Sub Total</span>
                  <span className="font-bold text-slate-800 font-mono">
                    ₹{fmtNum(subTotal)}
                  </span>
                </div>

                {/* ── Discount inputs ── */}
                <div className="py-2 border-b border-blue-50 space-y-2">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-slate-600 font-medium">Discount</span>
                    <select
                      value={form.discountType || ""}
                      onChange={(e) =>
                        set("discountType", e.target.value || "")
                      }
                      className="text-xs border border-blue-200 rounded-lg px-2 py-1.5 bg-blue-50/60 focus:outline-none focus:border-blue-500"
                    >
                      <option value="">None</option>
                      <option value="percentage">Percentage (%)</option>
                      <option value="fixed">Fixed (₹)</option>
                    </select>
                  </div>

                  {form.discountType && (
                    <div className="flex items-center justify-between gap-2">
                      <span className="text-xs text-slate-400">
                        {form.discountType === "percentage"
                          ? "Discount %"
                          : "Discount Amount (₹)"}
                      </span>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={form.discountValue}
                        onChange={(e) =>
                          set("discountValue", Number(e.target.value))
                        }
                        className="w-24 text-right border border-blue-200 rounded-lg px-2 py-1 text-xs bg-blue-50 focus:outline-none focus:border-blue-500"
                        placeholder="0"
                      />
                    </div>
                  )}

                  {discountAmount > 0 && (
                    <div className="flex justify-between">
                      <span className="text-xs text-red-500 font-medium">
                        Discount Applied
                      </span>
                      <span className="text-xs font-semibold text-red-500 font-mono">
                        − ₹{fmtNum(discountAmount)}
                      </span>
                    </div>
                  )}
                </div>

                <div className="flex justify-between py-1.5 border-b border-blue-50">
                  <span className="text-slate-600 font-medium">
                    Taxable Amount
                  </span>
                  <span className="font-bold text-slate-800 font-mono">
                    ₹{fmtNum(taxableAmount)}
                  </span>
                </div>

                <div className="flex justify-between py-1.5">
                  <span className="text-slate-500 text-xs">
                    CGST ({form.cgstRate}%)
                  </span>
                  <span className="font-semibold text-emerald-600 font-mono text-xs">
                    ₹{fmtNum(cgstAmt)}
                  </span>
                </div>
                <div className="flex justify-between py-1.5 border-b border-blue-50">
                  <span className="text-slate-500 text-xs">
                    SGST ({form.sgstRate}%)
                  </span>
                  <span className="font-semibold text-emerald-600 font-mono text-xs">
                    ₹{fmtNum(sgstAmt)}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-3 border-t-2 border-indigo-600/20">
                  <span className="text-indigo-800 font-bold text-sm">
                    TOTAL
                  </span>
                  <span className="font-extrabold text-indigo-700 text-lg font-mono">
                    ₹{fmtNum(total)}
                  </span>
                </div>

                {total > 0 && (
                  <div className="mt-2 px-3 py-2 bg-slate-50 border border-slate-100 rounded-lg">
                    <div className="text-[10px] text-slate-400 uppercase tracking-widest mb-0.5">
                      Amount in words
                    </div>
                    <div className="text-xs font-semibold text-slate-700 italic">
                      Rupees {amtWords}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ── Action Buttons ── */}
        <div className="flex justify-end gap-3 flex-wrap">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 px-6 py-2.5 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 font-semibold transition"
          >
            <RiArrowLeftLine className="w-4 h-4" /> Cancel
          </button>

          <button
            onClick={handleDownloadPDF}
            className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold border border-indigo-200 text-indigo-600 hover:bg-indigo-50 transition"
          >
            <RiDownload2Line className="w-4 h-4" /> Download PDF
          </button>

          <button
            onClick={handleSubmit}
            disabled={submitting}
            className="flex items-center gap-2 px-7 py-2.5 rounded-xl text-sm font-bold bg-indigo-600 hover:bg-indigo-700 text-white transition shadow-lg shadow-indigo-200 disabled:opacity-60"
          >
            {submitting ? <Spinner /> : <RiCheckLine className="w-4 h-4" />}
            {submitting ? "Creating…" : "Create Invoice"}
          </button>
        </div>
      </div>

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
